<template>
  <section>
    <!--
    <v-container fluid>
      <div :class="paper">
    -->
    <div v-for="(img, index) in images" :key="index">
      <PrintCanvas id="print-area" :class="paper"
        :sourceImage="img.image" :zoom="img.zoom"
        :centerx="img.centerx" :centery="img.centery"
        v-if="useCanvas"/>
      <BrowseImage :imageUrl="img" :paper="paper" :descText="descText"
        :style="printStyle"
        v-else/>
    </div>
    <!--
      </div>
    </v-container>
    -->
  </section>
</template>

<script>
import BrowseImage from '../components/BrowseImage.vue'
import PrintCanvas from '../views/PrintCanvas.vue';
export default {
  components: {
    BrowseImage,
    PrintCanvas,
  },
  props: {
    useCanvas: {
      type: Boolean,
      default: false,
    },
    images: {
      type: Array,
      default: null,
    },
    paper: {
      type: String,
      default: 'A4',
    },
    descText: {
      type: Array,
      default: null,
    },
    imageWidth: {
      type: Number,
      default: 420,
    },
    imageHeight: {
      type: Number,
      default: 296,
    }
  },
  computed: {
    printStyle() {
      let w = 420 - 22;
      let h = 296 - 26;
      const paperRatio = h / w;
      const imageRatio = this.imageHeight / this.imageWidth;
      //const hRatio = h / this.imageHeight;
      //const wRatio = w / this.imageWidth;
      if (paperRatio < imageRatio) {
        w = h / imageRatio;
      }
      else {
        h = w * imageRatio;
      }
      return `width:${w}mm;height:${h}mm`;
    }
  },
  mounted () {
    //console.log(`PrintImage: images=${this.images.length}`);
    this.$store.commit('setPrinting', true);
    //ToDo: 画像のロード待ちが必要か
    //ToDo: 用紙サイズの調整
    setTimeout(() => {
      window.print();
      this.$store.commit('setPrinting', false);
      this.$router.back();
    }, 1000);
  },
}
</script>
<style lang="scss" scoped>
.A4 {
  //width: 210mm;
  //height: 296mm;
  width: 190mm;
  height: 276mm;
  //width: 172mm;
  //height: 251mm;
  page-break-after: auto;
  background-color: white;
}
.A4R {
  width: 296mm;
  height: 210mm;
  page-break-after: auto;
  background-color: white;
}
.A3 {
  width: 296mm;
  height: 420mm;
  page-break-after: auto;
  background-color: white;
}
.A3R {
  /*
  width: calc(420mm - 22mm);
  height: calc(296mm - 26mm);
  */
  ///*  //split OK
  //width: 400mm;
  //height: 276mm;
  width: 404mm;
  height: 270mm;
  //*/
  /*  //split NG
  width: 420mm;
  height: auto;
  position: absolute;
  */
  margin: 0;
  padding: 0;
  page-break-after: none;
  background-color: white;
}
@media print {
  @page {
    //size: A3 landscape !important;
    size: auto !important;
    margin: 0;
    background: none !important;
  }
  body {
    margin: 0mm;
    padding: 0mm;
    background: none !important;
  }
  main {
    margin: 0mm;
    padding: 0mm;
    background: none !important;
  }
  ///* //これを入れれば1枚に収まる？
  .A3R {
    //width: calc(420mm - 22mm);
    height: calc(296mm - 26mm);
    width: auto;
    //page-break-after: always;
  }
  //*/
}
</style>
